import { Component, EventEmitter, OnDestroy, inject } from "@angular/core";
import { LocalStorageService } from "../services/local-storage.service";
import { SettingsService } from "../services/settings.service";
import { TimerService } from "../services/timer.service";
import { ITimer } from "../timer/timer.interface";
import { takeUntil, tap } from "rxjs/operators";

@Component({
    selector: "nx-extendable-information-panel",
    templateUrl: "./extendable-information-panel.component.html",
    styleUrls: ["./extendable-information-panel.component.scss"],
    standalone: false
})
export class ExtendableInformationPanelComponent implements OnDestroy {
  timerService = inject(TimerService);
  settingsService = inject(SettingsService);
  private _localStorageService = inject(LocalStorageService);

  public autoStoppedTimer: ITimer = LocalStorageService.getItem("autoStoppedTimer");
  public panelIsExpanded = LocalStorageService.getItem("settings")["pinnedTimers"]["panelExpanded"];
  private _destroyEmitter = new EventEmitter<void>();

  constructor() {
    this._localStorageService.localStorageChange$
      .pipe(
        takeUntil(this._destroyEmitter),
        tap(() => this.autoStoppedTimer = LocalStorageService.getItem("autoStoppedTimer")),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this._destroyEmitter.next();
  }
}
